import { useApolloClient } from "@apollo/client";
import { VariantPanelFragmentDoc } from "../types";
export const useRemoveVariant = ({ id, productId, benefitId, benefitKind }) => {
    const client = useApolloClient();
    return () => {
        if (productId) {
            client.cache.modify({
                id: `Product:${productId}`,
                fields: {
                    variants(existingVariantRefs = []) {
                        const filtered = existingVariantRefs.filter((v) => v.__ref !== `Variant:${id}`);
                        return [...filtered];
                    }
                }
            });
        }
        else if (benefitId) {
            client.cache.modify({
                id: `${benefitKind}:${benefitId}`,
                fields: {
                    variants(existingVariantRefs = []) {
                        const filtered = existingVariantRefs.filter((v) => v.__ref !== `Variant:${id}`);
                        return [...filtered];
                    }
                }
            });
        }
    };
};
export const useUpdateVariant = ({ id, field, isSelectValue }) => {
    const client = useApolloClient();
    // @ts-ignore
    return (value) => {
        var _a;
        const current = client.readFragment({
            id: `Variant:${id}`,
            fragment: VariantPanelFragmentDoc,
        });
        let fieldValue;
        switch (field) {
            case 'curationExcludeProducts':
                fieldValue = isSelectValue ?
                    Array.from(new Set([...current.curationExcludeProducts, value]))
                    :
                        current.curationExcludeProducts.filter((eachValue) => eachValue !== value);
                break;
            case 'curationIncludeVariants':
                fieldValue = isSelectValue ?
                    Array.from(new Set([...current.curationIncludeVariants, value]))
                    :
                        current.curationIncludeVariants.filter((eachValue) => eachValue !== value);
                break;
            case 'platformId':
                fieldValue = isSelectValue ?
                    (Array.isArray(value) && value.length > 0)
                        ? value.map(eachValue => eachValue.value.split(",")[0].split("/").pop()).join(",")
                        : ""
                    : value.target.value;
                break;
            default:
                fieldValue = value.target.value;
                break;
        }
        client.cache.evict({ id: `Variant:${id}` });
        client.writeFragment({
            id: `Variant:${id}`,
            fragment: VariantPanelFragmentDoc,
            data: Object.assign(Object.assign({}, current), { description: (isSelectValue && !current.description.trim() && Array.isArray(value) && value.length > 0)
                    ? (_a = value[0]) === null || _a === void 0 ? void 0 : _a.value.split(",")[1]
                    : current.description, 
                //@ts-ignore
                [field]: fieldValue }),
        });
    };
};
